/** Newest first; Total row stays at end. */
export const sortLedgerRowsByDateDesc = (rows) => {
  if (!Array.isArray(rows)) return [];
  const totals = rows.filter((r) => r.desc === "Total");
  const data = rows.filter((r) => r.desc !== "Total");
  data.sort((a, b) => {
    const dateDiff = Number(b.date || 0) - Number(a.date || 0);
    if (dateDiff !== 0) return dateDiff;
    return String(b.invoice || "").localeCompare(String(a.invoice || ""));
  });
  return [...data, ...totals];
};
